<template>
  <div class="cm-head">
    <div class="cm-top-bar">
      <div class="owidth">
        <p v-if="!user" class="cm-top-login">
          <span @click="toLogin">登录</span>
          /
          <span @click="register">注册</span>
        </p>
        <el-dropdown v-else class="cm-dropdown cm-top-login">
          <el-button>
            {{ loginName }}，您好！<i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><router-link to="/userindex"
                >进入个人中心</router-link
              ></el-dropdown-item
            >
            <el-dropdown-item @click.native="doLogout"
              ><img
                class="cm-top-abort-icon"
                src="@/assets/icon-abort.png"
              />退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <router-link
          class="cm-top-contact-us"
          to="/communicate/1530397486772035586"
          >联系我们</router-link
        >
        <p class="cm-top-bar-greeting">欢迎访问{{ comName }}官方网站！</p>
      </div>
    </div>
    <div class="cm-head-back">
      <div class="owidth">
        <img src="@/assets/top-text2.png" /><img src="@/assets/top-text.png" />
      </div>
    </div>
    <div class="cm-nav">
      <ul class="owidth">
        <li
          v-for="(item, index) in columns"
          :key="index"
          class="cm-nav-item"
          :class="
            access == columnMap[item.id].access ? 'cm-nav-item-active' : ''
          "
        >
          <router-link :to="columnMap[item.id].columnPath">
            {{ item.name }}
          </router-link>
        </li>
        
      </ul>
      
    </div>

    <el-dialog
      title="登录"
      :visible.sync="showLoginPnl"
      width="30%"
      center
      class="login-form"
    >
      <el-form
        class="cm-container"
        ref="accountForm"
        :model="formData"
        :rules="accountRules"
      >
        <p class="login-form-tip">河南省药品审评查验中心</p>
        <el-form-item prop="username">
          <img src="@/assets/icon-user.png" class="login-form-icon" />
          <el-input
            v-model.trim="formData.username"
            placeholder="用户名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <img src="@/assets/icon-pwd.png" class="login-form-icon" />
          <el-input
            class=""
            v-model="formData.password"
            type="password"
            placeholder="密码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <img
            class="vali-style-0-code"
            :src="valiCodeImg"
            @click="newValiCode"
          />
          <el-input
            v-model="formData.code"
            class="vali-style-0"
            placeholder="验证码"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span @click="register" class="to-register">注册</span>
      <span slot="footer" class="dialog-footer login-form-button">
        <el-button @click="showLoginPnl = false">取 消</el-button>
        <el-button type="primary" @click="doLogin('accountForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import {
  companyName,
  userTokenName,
  cmNavMenu,
  loginRole,
  loginUser,
  siteInfo,
} from "@/utils/auth.js";
import { getOneColumn, getSiteInfo } from "@/api/api.js";
import { getValiCode, login, getUserInfo, getFullUserInfo } from "@/api/api.js";
export default {
  name: "Head",
  data() {
    return {
      comName: "",
      access: "",
      showLoginPnl: false,
      user:
        localStorage.getItem(loginUser) &&
        JSON.parse(localStorage.getItem(loginUser)),
      loginName: "",
      formData: {
        username: "",
        password: "",
        uuid: "",
        code: "",
      },
      valiCodeImg: "",
      accountRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },
      inputType: "password",
      columns: [],
      columnMap: {
        52: {
          // name: "网站首页",
          access: "index",
          columnPath: "/",
        },
        53: {
          // name: "单位概况",
          access: "about",
          columnPath: "/about/83",
        },
        54: {
          // name: "动态要闻",
          access: "infolist",
          columnPath: "/infolist/85",
        },
        93: {
          // name: "公告通知",
          access: "notice",
          columnPath: "/notice/94",
        },
        95: {
          // name: "办事服务",
          access: "service",
          columnPath: "/service/1530391355416813570",
        },
        97: {
          // name: "政策法规",
          access: "policy",
          columnPath: "/policy/97",
        },
        "1530394238535245825": {
          // name: "互动交流",
          access: "communicate",
          columnPath: "/communicate/1530396726143393794",
        },
        102: {
          // name: "专题专栏",
          access: "special",
          columnPath: "/special/102",
        },
      },
    };
  },
  methods: {
    register() {
      this.showLoginPnl = false;
      this.$router.push("/register");
    },
    toLogin() {
      this.newValiCode();
      this.showLoginPnl = true;
    },
    newValiCode() {
      getValiCode({}).then((res) => {
        this.valiCodeImg = `data:image/gif;base64,${res.codeImg}`;
        this.formData.uuid = res.uuid;
      });
    },
    doLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          login(this.formData)
            .then((res) => {
              Cookie.set(userTokenName, res.token);
              localStorage.setItem(userTokenName, res.token);
              // this.$alert("", "登录成功", {
              //   confirmButtonText: "确定",
              //   center: true,
              //   type: "success",
              //   callback: (action) => {},
              // });
              this.$message.success("登录成功");
              this.showLoginPnl = false;
              this.$refs[formName].resetFields();
              getUserInfo({ token: res.token })
                .then((res) => {
                  localStorage.setItem(loginRole, JSON.stringify(res.role));
                  getFullUserInfo({ id: res.user.id }).then((res1) => {
                    this.user = res1;
                    localStorage.setItem(loginUser, JSON.stringify(res1));
                    this.loginName = res1.loginName;
                    if (location.href.indexOf("/userindex") >= 0) {
                      location.reload();
                    } else {
                      this.$router.push("/userindex");
                    }
                  });
                })
                .catch((err) => {
                  this.$message.error(err.response.data);
                });
            })
            .catch((err) => {
              this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getLoginName() {
      let user = localStorage.getItem(loginUser);
      if (user) this.loginName = JSON.parse(user).loginName;
    },
    doLogout() {
      this.$confirm("即将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          Cookie.remove(userTokenName);
          localStorage.removeItem(userTokenName);
          localStorage.removeItem(loginRole);
          localStorage.removeItem(loginUser);
          this.user = null;
          this.$router.push("/");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getCompanyName() {
      this.comName =
        localStorage.getItem(companyName) || "河南省药品审评查验中心";
    },
    getNavMenu() {
      try {
        this.columns = JSON.parse(localStorage.getItem(cmNavMenu));
      } catch (e) {}
      getOneColumn({}).then((res) => {
        this.columns = res;
        localStorage.setItem(cmNavMenu, JSON.stringify(res));
        this.getCompanyName();
        this.getLoginName();
      });
    },
  },
  created() {
    this.getNavMenu();
    this.access = this.$route.meta.access;
  },
};
</script>

<style scoped>
.cm-top-bar {
  position: absolute;
  top: 0;
  z-index: 1;
  height: 64px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.7);
}
.cm-top-bar-greeting {
  float: left;
  line-height: 64px;
  color: #366bc2;
  letter-spacing: 0.5px;
}
.cm-head-back {
  height: 320px;
  box-sizing: border-box;
  padding-top: 120px;
  background-image: url("@/assets/top-back.jpg");
  background-size: auto 100%;
}
.cm-head-back img:nth-child(1) {
  float: right;
  margin-top: 40px;
  
}
.cm-nav {
  background-color: #3469c1;
  line-height: 60px;
  height: 60px;
  text-align: center;
}
.cm-nav .owidth {
  display: flex;
  justify-content: space-between;
}
.cm-nav-item {
  /* width: 20%; */
  width: 10%;
}
.cm-nav-item a {
  display: block;
  color: #fff;
}
.cm-nav-item a:hover,
.cm-nav-item-active {
  background-color: #0d4fb3;
}
.cm-top-contact-us {
  float: right;
  line-height: 40px;
  margin-top: 12px;
  margin-right: 20px;
  color: #366ac1;
}
.cm-top-contact-us:hover {
  text-decoration: underline;
}
.cm-top-login {
  float: right;
  background-color: #3469c1;
  height: 40px;
  line-height: 38px;
  padding: 0 20px;
  border-radius: 20px;
  color: #fff;
  margin-top: 12px;
}
.cm-top-login * {
  color: #fff;
  font-size: 14px !important;
  cursor: pointer;
}
.cm-top-login *:hover {
  text-decoration: underline;
}
.el-dropdown-menu__item a {
  font-size: 14px;
  color: #606266;
}
.el-dropdown-menu__item:hover {
  color: #606266;
}
.cm-dropdown .el-button {
  float: right;
  border: none;
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
}
.cm-top-abort-icon {
  margin-right: 10px;
}
.login-form-tip {
  color: #666;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}
.to-register {
  font-size: 18px;
  cursor: pointer;
}
</style>
